import React, { useState, useEffect } from "react";
import axios from "axios";
import "./ReminderCards.css";
import html2canvas from "html2canvas";

const ReminderCards = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [allProducts, setAllProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [gridSize, setGridSize] = useState(4);
  const [showDropdown, setShowDropdown] = useState(false);
  const [loading, setLoading] = useState(true);

  const fetchProducts = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/products/download`
      );
      setAllProducts(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching products", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  useEffect(() => {
    if (searchTerm) {
      const filtered = allProducts.filter((product) =>
        product.brand_name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredProducts(filtered);
      setShowDropdown(true);
    } else {
      setFilteredProducts([]);
      setShowDropdown(false);
    }
  }, [searchTerm, allProducts]);

  const handleAddProduct = (product) => {
    if (selectedProducts.length < gridSize) {
      setSelectedProducts([
        ...selectedProducts,
        { ...product, color: getRandomColor(), font: getRandomFont() }, // Assign color and font only here
      ]);
      setSearchTerm("");
      setShowDropdown(false);
    } else {
      alert("Maximum products added!");
    }
  };

  const handleRemoveProduct = (index) => {
    const newSelectedProducts = [...selectedProducts];
    newSelectedProducts.splice(index, 1);
    setSelectedProducts(newSelectedProducts);
  };

  const DropdownItemStyle = {
    padding: "10px 15px",
    borderBottom: "1px solid #eee",
    cursor: "pointer",
    backgroundColor: "#fff",
    color: "#333",
  };

  const handleDownload = () => {
    const gridElement = document.querySelector(".grid");
    const clone = gridElement.cloneNode(true);
    const emptyCells = Array.from(clone.querySelectorAll(".empty"));
    emptyCells.forEach((cell) => cell.remove());

    document.body.appendChild(clone); // Temporarily add clone to document to manipulate

    if (selectedProducts.length <= 4) {
      clone.style.width = "700px";
    } else {
      clone.style.width = "800px";
    }
    clone.style.margin = "50px"; // Add margin around the grid
    clone.style.padding = "20px"; // Additional padding
    clone.style.backgroundColor = "#ffffff"; // Ensure background is white for download

    html2canvas(clone, {
      scale: 2,
      onclone: (document) => {
        document.body.appendChild(clone);
      },
    }).then((canvas) => {
      const link = document.createElement("a");
      link.href = canvas.toDataURL("image/png");
      link.download = "reminder-cards.png";
      link.click();
      // document.body.removeChild(clone); // Remove clone after download
    });
  };

  if (loading) {
    return <div className="loading">Data is loading...</div>;
  }

  return (
    <div className="container">
      <h1>Make Your Own Reminder Cards</h1>
      <div className="reminder-cards-top-bar">
        <label>
          Select Number of Products:
          <select
            value={gridSize}
            onChange={(e) => setGridSize(Number(e.target.value))}
          >
            {Array.from({ length: 8 }, (_, i) => (i + 1) * 2).map((size) => (
              <option key={size} value={size}>
                {size}
              </option>
            ))}
          </select>
        </label>
        <button
          onClick={handleDownload}
          disabled={selectedProducts.length === 0}
        >
          Download as Image
        </button>
      </div>
      <label>
        Add Product in Reminder Card:
        <input
          type="text"
          placeholder="Type Brand Name of Product to add..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </label>
      {showDropdown && (
        <div className="dropdown">
          {filteredProducts.map((product, index) => (
            <div
              key={index}
              className="dropdown-item"
              style={DropdownItemStyle}
              onClick={() => handleAddProduct(product)}
            >
              {product.brand_name}
            </div>
          ))}
        </div>
      )}
      <div className="grid">
        {Array.from({ length: gridSize }).map((_, index) => (
          <div
            key={index}
            className={`grid-cell ${selectedProducts[index] ? "" : "empty"}`}
          >
            {selectedProducts[index] ? (
              <>
                <span
                  className="remove-icon"
                  onClick={() => handleRemoveProduct(index)}
                >
                  &times;
                </span>
                <h2
                  style={{
                    color: selectedProducts[index].color,
                    font: selectedProducts[index].font,
                    fontSize: 30,
                  }}
                  contentEditable
                >
                  {selectedProducts[index].brand_name}
                </h2>
                <p contentEditable>{selectedProducts[index].compostion}</p>
              </>
            ) : (
              "Add Product"
            )}{" "}
          </div>
        ))}
      </div>
    </div>
  );
};

const getRandomColor = () => {
  const colors = [
    "#C0392B",
    "#E74C3C",
    "#9B59B6",
    "#8E44AD",
    "#2980B9",
    "#3498DB",
    "#1ABC9C",
    "#16A085",
    "#27AE60",
    "#2ECC71",
    "#F1C40F",
    "#F39C12",
    "#E67E22",
    "#D35400",
    "#34495E",
    "#2C3E50",
    "#7D3C98",
  ];
  return colors[Math.floor(Math.random() * colors.length)];
};

const getRandomFont = () => {
  const fonts = [
    "Arial Black",
    "Comic Sans MS",
    "Impact",
    "Lucida Sans",
    "Tahoma",
    "Verdana",
    "Helvetica",
    "Times New Roman",
    "Georgia",
    "Garamond",
    "Courier New",
    "Brush Script MT",
    "Lucida Bright",
    "Lucida Fax",
    "Palatino Linotype",
    "Constantia",
    "Franklin Gothic Medium",
    "Berlin Sans FB",
    "Britannic Bold",
    "Cambria",
  ];
  return fonts[Math.floor(Math.random() * fonts.length)];
};

export default ReminderCards;
